import { useState, useEffect, useCallback } from 'react';

import EmployerProfile
from './EmployerProfile';

import EmployerJobManager
from './EmployerJobManager';

import EmployerApplications
from './EmployerApplications';

import {
  getEmployerJobs
} from '../services/jobService';

export default function EmployerDashboard() {

  const [tab, setTab] =
    useState('profile');

  const [jobs, setJobs] = useState([]);
  const loadJobs = useCallback(
    async () => {

      try {

        const employerJobs =
          await getEmployerJobs();

        setJobs(employerJobs);

      } catch (error) {

        console.error(
          'Failed to load jobs:',
          error
        );

      } finally {

      }
    },
    []
  );
  useEffect(() => {
    loadJobs();
  }, [loadJobs]);

  return (

    <div className="employerDashboard">

      <div className="dashboardTabs">

        <button
          className={
            tab === 'profile'
              ? 'active'
              : ''
          }
          onClick={() =>
            setTab('profile')
          }
        >
          Company Profile
        </button>

        <button
          className={
            tab === 'jobs'
              ? 'active'
              : ''
          }
          onClick={() =>
            setTab('jobs')
          }
        >
          Jobs
        </button>

        <button
          className={
            tab === 'applications'
              ? 'active'
              : ''
          }
          onClick={() =>
            setTab('applications')
          }
        >
          Applications
        </button>

      </div>

      {
        tab === 'profile' &&
        <EmployerProfile />
      }

      {
        tab === 'jobs' &&
        (
          <EmployerJobManager
            jobs={jobs}
            reloadJobs={loadJobs}
          />
        )
      }

      {
        tab === 'applications' &&
        <EmployerApplications />
      }

    </div>
  );
}